import { Link, useLocation, useNavigate } from "react-router-dom"
// import profileImg from "../../assets/Rectangle 1393.png"
// import notifications from "../../assets/clarity_notification-line.png"
import { BsList } from "react-icons/bs"; // Using Bootstrap List Icon
import Offcanvas from 'react-bootstrap/Offcanvas';
import "./AuthNavbar.css"
import Sidebar from "../../Components/Sidebar/Sidebar"
import { useEffect, useState } from "react"
import { data } from '../../Lessons'

function AuthNavbar() {
const location = useLocation();

useEffect(() => {
  handleClose(); // أغلق Offcanvas عند تغيير الرابط
}, [location.pathname]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [show, setShow] = useState(false);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    // eslint-disable-next-line react-hooks/rules-of-hooks

    // const sidebarItems = userinfo && userinfo.role === "Super Admin" ? [
    //     { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
    //     { name: currentLocal.home.schools, icon: bank, path: "Schools" },
    //     { name: currentLocal.home.settings, icon: bank,path:"settings" },
    
        
    
    
    //   ] : userinfo && userinfo.role === "School Manager" ? [
    
    //     { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
    //     {
    //       name:currentLocal.home.SchoolStracture , icon: profile, path: "school-structure", subTabs: [
    //         { name: currentLocal.home.stages, icon: profile, path: "structure/stages" },
    //         { name: currentLocal.home.grades, icon: profile, path: "structure/grades" }
    //       ]
    //     },
    //     { name:currentLocal.home.subjects, icon: profile, path: "Subjects" },
    //     { name:currentLocal.home.teachers , icon: profile, path: "Teachers" },
    
    //     { name: currentLocal.home.classes, icon: profile, path: "Classes" },
    //     { name:currentLocal.home.students , icon: profile, path: "Students" },
    //     { name:currentLocal.home.attendanceHistory, icon: profile, path: "attendance-history" },
    
    
    
    
    
    //   ] : [
    //     { name: currentLocal.home.dashboard, icon: home, path: "dashboard" },
    //     { name:currentLocal.home.markAttendance, icon: profile, path: "mark-attendance" },
    //     // { name: "Attendance History", icon: mingcute,path:"attendance-history" },
    //   ]

const sidebarItems = [
  { name: "الأهداف العامة", path: "dashboard" },

  ...data.map((item) => ({
    name: item.name,       // أو item.name حسب ملف الدروس
    path: `lesson/${item.id}`
  })),

  { name: "الدعم و المساعدة", path: "help" },
];
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    const navigate = useNavigate();
    // eslint-disable-next-line react-hooks/rules-of-hooks


  
    
    return (
        <div className="authNavbar_container ">
            <div className="w-100 d-flex align-items-center justify-content-between py-3">
                <div>
                    <div className="mx-2 list_container" onClick={handleShow}>
                        <BsList size={24} />
                    </div>
                    <Offcanvas show={show} onHide={handleClose}>
                        <Offcanvas.Header closeButton style={{ backgroundColor: "#2D103A" }}>
                        </Offcanvas.Header>
                        <Offcanvas.Body className="p-0">
                            <Sidebar
                                sidebarItems={sidebarItems}
                            />
                        </Offcanvas.Body>
                    </Offcanvas>
                </div>

                <div className="d-flex  align-items-center ">
                    <div>
                        <div className="nav-item dropdown d-flex justify-content-center align-items-center">
                    
                  
                        </div>
                    </div>

            

                </div>
            </div>
        </div>
    )
}

export default AuthNavbar


